import { isEmpty } from 'lodash';
import { useMemo, useState } from 'react';

export interface SelectedUsers {
  token: string | null;
  userIds: number[] | null;
}

export interface DefaultPersonSelectionHooks {
  selectedUsers?: SelectedUsers;
  filteredUsers?: MBAPI.ShortUser[];
  onFilter(filter: string);
  currentFilter: string;
  onPersonSelected(userId: number);
  onMeSelected();
}

export function useDefaultPersonSelectionHooks(
  users: MBAPI.ShortUser[],
  selectedUsers: SelectedUsers,
  onPersonSelected: (userId: number) => void,
  onMeSelected: () => void,
): DefaultPersonSelectionHooks {
  const [filterQuery, setFilterQuery] = useState<string>('');

  const filteredUsers = useMemo(() => {
    if (isEmpty(filterQuery)) {
      return users;
    } else {
      const lowercaseQuery = filterQuery.toLowerCase();
      return users.filter(user => {
        return (
          user.fullName.toLowerCase().includes(lowercaseQuery) ||
          user.username.toLowerCase().includes(lowercaseQuery)
        );
      });
    }
  }, [filterQuery, users]);

  return {
    selectedUsers: selectedUsers,
    filteredUsers: filteredUsers,
    onFilter: setFilterQuery,
    currentFilter: filterQuery,
    onPersonSelected: onPersonSelected,
    onMeSelected: onMeSelected,
  };
}
